// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const moneyflowTracker = "MoneyflowTracker__moneyflowTracker__ZjrFg";
export const moneyflowTrackerInner = "MoneyflowTracker__moneyflowTrackerInner__mDPpm";
export const tracker = "MoneyflowTracker__tracker__L+cdD";
export const trackerInner = "MoneyflowTracker__trackerInner__dwSlc";
export const expanded = "MoneyflowTracker__expanded__yJF4Z";
export const actionLinks = "MoneyflowTracker__actionLinks__hTGGO";
export const linkWrapper = "MoneyflowTracker__linkWrapper__lwv6r";
export const trackerIcon = "MoneyflowTracker__trackerIcon__hDfSJ";
export const nameWrapper = "MoneyflowTracker__nameWrapper__aAu3h Breakdown__nameWrapper__lE60L";
export const name = "MoneyflowTracker__name__20XYk";
export const trackerDetails = "MoneyflowTracker__trackerDetails__FG0vb";
export const danger = "MoneyflowTracker__danger__0e-Ot";
export const value = "MoneyflowTracker__value__8FaHL";
export const warning = "MoneyflowTracker__warning__+Q24S";
export const onTrack = "MoneyflowTracker__onTrack__DICwf";
export const emphasis = "MoneyflowTracker__emphasis__ZCxtA";
export const text = "MoneyflowTracker__text__1E3jK";